<template>
  <div class="page">
    <div class="container">
      <header class="header">
        <div class="brand">
          <img class="logo" src="/word_header_logo.png" alt="" aria-hidden="true" />
          <div>
            <div class="brand-title">AI视频面试平台</div>
            <div class="brand-sub">候选人入场 · 设备检测 · 防作弊确认</div>
          </div>
        </div>

      </header>

      <main>
        <section class="stepper" aria-label="步骤导航">
          <div
            class="step"
            :class="{ active: step === 1, done: step >= 2 }"
            aria-label="第1步：设备检测"
          >
            <div class="dot" aria-hidden="true"></div>
            <div>
              <div class="title">第1步：设备检测</div>
              <div class="sub">摄像头 / 麦克风 / 网络</div>
            </div>
          </div>
          <div class="arrow" aria-hidden="true">→</div>
          <div
            class="step"
            :class="{ active: step === 2 || step === 3, done: step > 2 }"
            aria-label="第2步：准备就绪"
          >
            <div class="dot" aria-hidden="true"></div>
            <div>
              <div class="title">第2步：准备就绪</div>
              <div class="sub">声纹采集 + 面试承诺</div>
            </div>
          </div>
        </section>

        <section class="content" aria-label="主内容区域">
          <div class="content-inner">
            <!-- STEP 1 -->
            <div v-show="step === 1" class="step-content">
              <div class="grid">
                <div class="card">
                  <div class="card-h">
                    <strong>摄像头实时预览</strong>
                    <div class="btn-row">
                      <el-button size="small" native-type="button" id="fullscreenBtn" class="ghost" @click="toggleFullscreen">
                        全屏测试
                      </el-button>
                    </div>
                  </div>
                  <div
                    ref="previewVideoWrap"
                    class="video-wrap"
                    :class="{ 'video-wrap--preview-flip-shell': previewMirrorOnShell }"
                  >
                    <div class="local-preview-flip">
                      <video
                        ref="preview"
                        class="local-mirror-preview"
                        :class="{ 'local-mirror-preview--css-flip': previewMirrorOnVideo }"
                        autoplay
                        playsinline
                        muted
                      ></video>
                    </div>
                    <button
                      v-if="isPreviewFullscreen"
                      type="button"
                      class="fs-exit-btn"
                      aria-label="退出全屏"
                      @click="exitFullscreen"
                    >
                      <img class="fs-exit-icon" :src="mobileIcons.fullscreenExit" alt="" aria-hidden="true" />
                    </button>
                    <div class="video-overlay">
                      <div class="badge-row" aria-label="实时提示">
                        <span
                          class="badge"
                          :class="camStatusType"
                        >
                          摄像头：{{ camStatusText }}
                        </span>
                        <span
                          class="badge"
                          :class="micStatusType"
                        >
                          麦克风：{{ micStatusText }}
                        </span>
                        <span
                          class="badge"
                          :class="
                            netLevel === 'ok'
                              ? 'ok'
                              : netLevel === 'warn'
                                ? 'warn'
                                : netLevel === 'bad'
                                  ? 'bad'
                                  : 'warn'
                          "
                        >
                          网络：{{ netText }}
                        </span>
                        <span
                          class="badge"
                          :class="
                            envLevel === 'ok'
                              ? 'ok'
                              : envLevel === 'warn'
                                ? 'warn'
                                : envLevel === 'bad'
                                  ? 'bad'
                                  : 'warn'
                          "
                        >
                          环境：{{ envBadgeText }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="card-b voice-collect-body">
                    <div class="fineprint">
                      - 进入页面会自动请求摄像头/麦克风权限，并展示预览画面。<br />
                      - 防作弊提示：建议关闭无关应用，避免切屏；面试过程中系统会记录关键事件用于复核。
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-h">
                    <strong>设备检测状态</strong>
                    <div class="btn-row">
                      <el-button size="small" native-type="button" @click="recheck">重新检测</el-button>
                    </div>
                  </div>
                  <div class="card-b">
                    <div class="list">
                      <div class="item">
                        <div class="left">
                          <div class="icon" aria-hidden="true">📷</div>
                          <div class="meta">
                            <div class="k-row">
                              <div class="k">摄像头检测</div>
                              <div
                                class="status status--mobile"
                                :class="camStatusType"
                              >
                                {{ camStatusText }}
                              </div>
                            </div>
                            <div class="d">{{ camDesc }}</div>
                          </div>
                        </div>
                        <div
                          class="status status--desktop"
                          :class="camStatusType"
                        >
                          {{ camStatusText }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="left">
                          <div class="icon" aria-hidden="true">🎙️</div>
                          <div class="meta">
                            <div class="k-row">
                              <div class="k">麦克风检测</div>
                              <div
                                class="status status--mobile"
                                :class="micStatusType"
                              >
                                {{ micStatusText }}
                              </div>
                            </div>
                            <div class="d">{{ micDesc }}</div>
                          </div>
                        </div>
                        <div
                          class="status status--desktop"
                          :class="micStatusType"
                        >
                          {{ micStatusText }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="left">
                          <div class="icon" aria-hidden="true">📶</div>
                          <div class="meta">
                            <div class="k-row">
                              <div class="k">网络检测</div>
                              <div
                                class="status status--mobile"
                                :class="
                                  netLevel === 'ok'
                                    ? 'ok'
                                    : netLevel === 'warn'
                                      ? 'warn'
                                      : netLevel === 'bad'
                                        ? 'bad'
                                        : 'warn'
                                "
                              >
                                {{
                                  netLevel === "ok"
                                    ? "正常"
                                    : netLevel === "warn"
                                    ? "⚠ 建议优化"
                                      : netLevel === "bad"
                                        ? "失败"
                                        : "… 检测中"
                                }}
                              </div>
                            </div>
                            <div class="d">{{ netDesc }}</div>
                          </div>
                        </div>
                        <div
                          class="status status--desktop"
                          :class="
                            netLevel === 'ok'
                              ? 'ok'
                              : netLevel === 'warn'
                                ? 'warn'
                                : netLevel === 'bad'
                                  ? 'bad'
                                  : 'warn'
                          "
                        >
                          {{
                            netLevel === "ok"
                              ? "正常"
                              : netLevel === "warn"
                              ? "⚠ 建议优化"
                                : netLevel === "bad"
                                  ? "失败"
                                  : "… 检测中"
                          }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="left">
                          <div class="icon" aria-hidden="true">🛡️</div>
                          <div class="meta">
                            <div class="k-row">
                              <div class="k">环境检测</div>
                              <div
                                class="status status--mobile"
                                :class="
                                  envLevel === 'ok'
                                    ? 'ok'
                                    : envLevel === 'warn'
                                      ? 'warn'
                                      : envLevel === 'bad'
                                        ? 'bad'
                                        : 'warn'
                                "
                              >
                                {{
                                  envLevel === "ok"
                                    ? "正常"
                                    : envLevel === "warn"
                                      ? "⚠ 风险"
                                      : envLevel === "bad"
                                        ? "× 疑似虚拟机"
                                        : "… 检测中"
                                }}
                              </div>
                            </div>
                            <div class="d">{{ envDesc }}</div>
                          </div>
                        </div>
                        <div
                          class="status status--desktop"
                          :class="
                            envLevel === 'ok'
                              ? 'ok'
                              : envLevel === 'warn'
                                ? 'warn'
                                : envLevel === 'bad'
                                  ? 'bad'
                                  : 'warn'
                          "
                        >
                          {{
                            envLevel === "ok"
                              ? "正常"
                              : envLevel === "warn"
                                ? "⚠ 风险"
                                : envLevel === "bad"
                                  ? "× 疑似虚拟机"
                                  : "… 检测中"
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="hr"></div>
                    <div class="note">
                      小提示：如果摄像头没有画面，请检查浏览器地址栏的权限标记；建议使用 Chrome/Edge
                      最新版。
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 等待室：准备就绪，等待面试官 -->
            <div v-show="step === 3" class="waiting-room">
              <h2 v-show="!roomReady">准备就绪，等待面试官</h2>
              <div v-show="!roomReady && !waitingError" class="spinner"></div>
              <div v-show="!roomReady" class="waiting-tip">
                <div class="waiting-tip-row waiting-tip-row--center">
                  <span class="wt-label">📌</span>
                  <span class="wt-value">面试官将在面试开始前进入房间</span>
                </div>
                <div class="waiting-tip-row waiting-tip-row--interview-time">
                  <span class="wt-label">⏱️ 面试时间：</span>
                  <span class="wt-value">{{ inviteInfo.interview_time || "--" }}</span>
                </div> 
                <div class="waiting-tip-row">
                  <span class="wt-label">👤 面试官：</span>
                  <span class="wt-value">{{ inviteInfo.interviewer || "--" }}</span>
                </div>
                <div class="waiting-tip-row">
                  <span class="wt-label">👥 招聘HR：</span>
                  <span class="wt-value">{{ inviteInfo.recruiters || "--" }}</span>
                </div>
                <div class="waiting-tip-row">
                  <span class="wt-label">📞 招聘HR电话：</span>
                  <span class="wt-value">{{ inviteInfo.recruiters_phone || "**********" }}</span>
                </div>
                <div class="countdown" style="width:320px;margin-left:-35px;">{{ countdownText }}</div>
              </div>
              <div v-show="roomReady" class="room-ready">
                <div class="room-ready-title">
                  <img :src="goodIcon" class="room-ready-good" alt="" aria-hidden="true" />
                  <div class="room-ready-title-text">面试官已进入房间</div>
                </div>
                <div class="room-ready-img-wrap">
                  <img :src="interviewImgPng" class="room-ready-interview-img" alt="" aria-hidden="true" />
                </div>
                <el-button
                  size="small"
                  native-type="button"
                  class="primary enter-btn"
                  :disabled="uploadingVoice"
                  @click="enterRoom"
                >
                  立即进入面试间
                </el-button>
              </div>
              <div v-show="waitingError" class="error-box">
                <p>❌ {{ waitingErrorMsg }}</p>
                <el-button size="small" native-type="button" class="primary" @click="retryPolling">重新检查</el-button>
              </div>
              <div style="margin-top: 20px">
                <el-button size="small" native-type="button" class="ghost" @click="backToPrep">返回准备页面</el-button>
              </div>
            </div>

            <!-- STEP 2 -->
            <div v-show="step === 2" class="step-content">
              <div class="split">
                <div class="card">
                  <div class="card-h">
                    <strong>声纹采集</strong>
                    <span
                      class="status"
                      :class="voice.url ? 'ok' : voice.recording ? 'warn' : ''"
                    >
                      {{ voiceStatusText }}
                    </span>
                  </div>
                  <div class="card-b" >
                    <div class="fineprint voice-read-tip" style="font-size: 16px;font-weight: 850;">
                      请朗读以下文本：<br />
                      <span class="mono voice-read-content"
                      style="font-size: 16px;font-weight: 850;"
                        >“我承诺独立完成面试，不查阅任何资料，不接受他人协助。”</span
                      >
                    </div>
                    <div class="btn-row" style="margin-top: 12px">
                      <el-button
                        size="small"
                        native-type="button"
                        class="primary"
                        @click="toggleVoiceRecord"
                      >
                        {{ voice.recording ? "结束录音" : (voice.url ? "重新录音" : "点击录音") }}
                      </el-button>
                      <el-button
                        size="small"
                        native-type="button"
                        :disabled="!voice.url || voice.recording"
                        @click="playVoice"
                      >
                        试听
                      </el-button>
                      <el-button
                        size="small"
                        native-type="button"
                        class="danger"
                        :disabled="!voice.url || voice.recording"
                        @click="clearVoice"
                      >
                        清除
                      </el-button>
                    </div>
                    <div v-show="!!voice.url" class="voice-audio-block">
                      <audio
                        ref="voiceAudio"
                        controls
                        class="voiceAudio"
                        preload="auto"
                        playsinline
                        :src="voice.playUrl || voice.url"
                        @loadedmetadata="syncVoiceAudioDisplayTimes"
                        @loadeddata="syncVoiceAudioDisplayTimes"
                        @durationchange="syncVoiceAudioDisplayTimes"
                        @timeupdate="syncVoiceAudioDisplayTimes"
                        @seeking="syncVoiceAudioDisplayTimes"
                        @seeked="syncVoiceAudioDisplayTimes"
                        @play="syncVoiceAudioDisplayTimes"
                        @pause="syncVoiceAudioDisplayTimes"
                        @ended="syncVoiceAudioDisplayTimes"
                      ></audio>
                      <div class="voice-audio-time fineprint" aria-live="polite">
                        录音时长：{{ Math.max(0, Math.floor(voiceDisplayTotalSec || 0)) }}秒
                      </div>
                    </div>
                    <div class="fineprint" style="margin-top: 5px">
                      {{ recordTipText }}
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-h">
                    <strong>面试承诺</strong>
                    <span
                      class="status"
                      :class="pledgesOk ? 'ok' : 'warn'"
                    >
                      {{ pledgesOk ? "已完成" : "未完成" }}
                    </span>
                  </div>
                  <div class="card-b">
                    <div class="checklist">
                      <label class="chk">
                        <input type="checkbox" v-model="pledges.p1" />
                        <span class="txt">
                          <span class="h">
                            我已阅读并同意
                            <a href="javascript:void 0" class="privacy-link" @click.prevent="openPrivacyDialog">《隐私协议》</a>
                          </span>
                          <span class="s"
                            >包含录制、风险事件留痕、数据保存期限等说明</span
                          >
                        </span>
                      </label>
                      <label class="chk">
                        <input type="checkbox" v-model="pledges.p2" />
                        <span class="txt">
                          <span class="h">我承诺独立完成面试，不使用 AI 插件</span>
                          <span class="s"
                            >包括但不限于：AI 代答、外挂提示、远程协助等</span
                          >
                        </span>
                      </label>
                      <label class="chk">
                        <input type="checkbox" v-model="pledges.p3" />
                        <span class="txt">
                          <span class="h">我了解作弊后果：取消资格、计入诚信档案</span>
                          <span class="s"
                            >系统将记录异常事件并提供复核依据</span
                          >
                        </span>
                      </label>
                    </div>
                    <div class="hr"></div>
                    <div class="note">
                      防作弊说明：系统会记录切屏、断网重连、设备变化等关键事件，面试官可在回放与报告中查看时间轴。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="Number(step) !== 3" class="footer" style="display: flex; justify-content: center">
            <div class="btn-row">
              <el-button size="small" native-type="button" :disabled="step === 1" @click="prev">上一步</el-button>
              <el-button
                size="small"
                native-type="button"
                class="primary next-action-btn"
                :class="{ 'next-action-btn--disabled': nextActionBlocked }"
                :aria-disabled="nextActionBlocked ? 'true' : 'false'"
                @click="onNextActionClick"
              >
                {{ uploadingVoice ? "上传声纹中..." : step === 2 ? "进入面试间" : "下一步" }}
              </el-button>
            </div>
          </div>
        </section>
      </main>
    </div>

    <el-dialog
      title="隐私协议"
      :visible.sync="privacyDialogVisible"
      width="650px"
      custom-class="doc-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @closed="privacyIframeKey = Date.now()"
    >
      <iframe
        :key="privacyIframeKey"
        v-show="privacyDialogVisible"
        src="/隐私协议.html"
        class="doc-iframe"
        frameborder="0"
      />
    </el-dialog>
  </div>
</template>

<script>
import { isIosLikeDevice } from "@/utils/isIosLikeDevice";
import { getInterviewRoomStatus } from "@/api/modules/interview/interview";
import { uploadVoiceprint } from "@/api/candidateAuth";
import Recorder from "recorder-core";
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";
import "recorder-core/src/engine/wav";
import goodIcon from "@/assets/good.png";
import interviewImgPng from "@/assets/interviewImg.png";

export default {
  name: "CandidateEntry",
  data() {
    return {
      step: 1,
      stream: null,
      camOk: false,
      micOk: false,
      isDeviceChecking: true,
      camDesc: "等待检测…",
      micDesc: "等待检测…",
      netLevel: "unknown",
      netText: "待检测",
      netDesc: "将评估网络状态与建议",
      isPreviewFullscreen: false,
      mobileIcons: {
        fullscreenExit: require("@/assets/icons/缩小@3x.png"),
      },

      // 环境风险检测（浏览器侧启发式：虚拟化/自动化/WebGL/设备特征等）
      envChecked: false,
      envLevel: "unknown", // ok | warn | bad | unknown
      envDesc: "等待检测…",

      pledges: { p1: false, p2: false, p3: false },

      voice: {
        recording: false,
        stream: null,
        recorder: null,
        mobileRecorder: null,
        chunks: [],
        blob: null,
        url: "",
        playUrl: "",
        /** 解码得到的时长（移动端原生 controls 常不显示总时长，用此兜底） */
        knownDurationSec: 0,
        displayCurrentSec: 0,
        displayTotalSec: 0,
        fallbackPlayer: null,
      },
      uploadingVoice: false,
      voiceUploaded: false,
      // 等待室
      roomReady: false,
      waitingError: false,
      waitingErrorMsg: "连接异常，请稍后重试",
      waitingStatus: "正在等待面试官进入房间...",
      pollInterval: null,
      waitingStartTime: null,
      countdownText: "",
      countdownTimer: null,

      // 等待室展示的面试邀请信息（从 CandidateLogin 写入 sessionStorage 获取）
      inviteInfo: {
        position: "",
        interview_id: "",
        interview_time: "",
        interviewer: "",
        recruiters: "",
        recruiters_phone: "",
      },
      privacyDialogVisible: false,
      privacyIframeKey: 0,
    };
  },
  computed: {
    previewMirrorOnShell() {
      return isIosLikeDevice();
    },
    previewMirrorOnVideo() {
      return !isIosLikeDevice();
    },
    name() {
      return this.$route.query.name || "";
    },
    phone() {
      return this.$route.query.phone || "";
    },
    interviewId() {
      try {
        const idFromSession = sessionStorage.getItem("candidate_interview_id");
        return String(idFromSession || this.inviteInfo.interview_id || "").trim();
      } catch (_) {
        return String(this.inviteInfo.interview_id || "").trim();
      }
    },
    goodIcon() {
      return goodIcon;
    },
    interviewImgPng() {
      return interviewImgPng;
    },
    pledgesOk() {
      return !!(this.pledges.p1 && this.pledges.p2 && this.pledges.p3);
    },
    voiceStatusText() {
      if (this.voice.recording) return "录制中";
      if (this.voice.url) return "已录制";
      return "未录制";
    },
    voiceStatusType() {
      if (this.voice.recording) return "warning";
      if (this.voice.url) return "success";
      return "info";
    },
    recordTipText() {
      if (this.voice.recording) return "录制中…请朗读文本，完成后再次点击按钮结束录音。";
      if (this.voice.url) return "录制完成：可试听，也可重新录制。";
      return "录音仅用于提升面试中身份一致性校验准确性。";
    },
    /** 展示用总秒数：优先元素合法 duration，否则用解码得到的 knownDurationSec */
    voiceDisplayTotalSec() {
      const fromUi = Number(this.voice.displayTotalSec);
      if (Number.isFinite(fromUi) && fromUi > 0) return fromUi;
      const known = Number(this.voice.knownDurationSec);
      return Number.isFinite(known) && known > 0 ? known : 0;
    },
    envBadgeText() {
      if (!this.envChecked) return "检测中";
      if (this.envLevel === "ok") return "正常";
      if (this.envLevel === "warn") return "需关注";
      if (this.envLevel === "bad") return "疑似虚拟机";
      return "未知";
    },
    camStatusType() {
      if (this.isDeviceChecking) return "warn";
      return this.camOk ? "ok" : "bad";
    },
    camStatusText() {
      if (this.isDeviceChecking) return "检测中";
      return this.camOk ? "正常" : "失败";
    },
    micStatusType() {
      if (this.isDeviceChecking) return "warn";
      return this.micOk ? "ok" : "bad";
    },
    micStatusText() {
      if (this.isDeviceChecking) return "检测中";
      return this.micOk ? "正常" : "失败";
    },
    canGoNext() {
      // 正式逻辑：必须完成摄像头/麦克风检测通过；
      // 环境只要出现风险（warn/bad）都不放行；
      // 网络“建议优化”(warn)允许继续，只有“失败”(bad)才阻断。
      if (this.step === 1) {
        const netOk = this.netLevel === "ok" || this.netLevel === "warn";
        return this.camOk && this.micOk && this.envChecked && this.envLevel === "ok" && netOk;
      }
      if (this.step === 2) {
        // 第 2 步：必须录音完成（生成音频）+ 勾选承诺
        return this.pledgesOk && !!this.voice.blob && !!this.voice.url && !this.voice.recording;
      }
      return false;
    },
    nextActionBlocked() {
      return !this.canGoNext || this.uploadingVoice;
    },
  },
  mounted() {
    this.loadInviteInfoFromSessionStorage();
    this.recheck();
    window.addEventListener("message", this.handleDocDialogMessage);
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", this.handleFullscreenChange);
  },
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    if (this.voice && this.voice.mobileRecorder) {
      try {
        this.voice.mobileRecorder.close();
      } catch (_) {
        // noop
      }
      this.voice.mobileRecorder = null;
    }
    if (this.voice && this.voice.fallbackPlayer && this.voice.fallbackPlayer.pause) {
      try {
        this.voice.fallbackPlayer.pause();
      } catch (_) {
        // noop
      }
      this.voice.fallbackPlayer = null;
    }
    this.stopStream();
    this.stopVoiceStream();
    this.revokeVoiceUrl();
    this.voice.blob = null;
    this.stopPolling();
    this.stopCountdown();
    window.removeEventListener("message", this.handleDocDialogMessage);
  },
  methods: {
    getFullscreenTarget() {
      return this.$refs.previewVideoWrap || null;
    },
    handleFullscreenChange() {
      const target = this.getFullscreenTarget();
      const activeEl = document.fullscreenElement || document.webkitFullscreenElement || null;
      this.isPreviewFullscreen = !!target && activeEl === target;
    },
    async recheck() {
      await this.startPreview();
      await Promise.all([this.checkNetwork(), this.checkEnvironment()]);
    },
    handleDocDialogMessage(event) {
      const data = event && event.data;
      if (!data || data.type !== "close-doc-dialog") return;
      if (data.doc === "privacy") {
        this.privacyDialogVisible = false;
      }
    },
    openPrivacyDialog() {
      this.privacyDialogVisible = true;
    },
    loadInviteInfoFromSessionStorage() {
      try {
        const raw = sessionStorage.getItem("candidate_invite_info");
        if (!raw) return;
        const parsed = JSON.parse(raw);
        this.inviteInfo = {
          position: parsed && parsed.position ? parsed.position : "",
          interview_id: parsed && parsed.interview_id ? parsed.interview_id : "",
          interview_time: parsed && parsed.interview_time ? parsed.interview_time : "",
          interviewer: parsed && parsed.interviewer ? parsed.interviewer : "",
          recruiters: parsed && parsed.recruiters ? parsed.recruiters : "",
          recruiters_phone: parsed && parsed.recruiters_phone ? parsed.recruiters_phone : "",
        };
        console.log(this.inviteInfo, '333333')
        if (this.inviteInfo.interview_id) {
          sessionStorage.setItem("candidate_interview_id", String(this.inviteInfo.interview_id));
        }
      } catch (_) {
        // ignore（比如 JSON 解析失败/存储不可用）
      }
    },
    async startPreview() {
      this.stopStream();
      this.camOk = false;
      this.micOk = false;
      this.isDeviceChecking = true;
      this.camDesc = "检测中…";
      this.micDesc = "检测中…";

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.camDesc = "未授权或无可使用摄像头，请检查浏览器权限";
        this.micDesc = "未授权或无可使用麦克风，请检查浏览器权限";
        this.isDeviceChecking = false;
        return;
      }

      let videoStream = null;
      let audioStream = null;

      // 分开请求可获得更精确的“摄像头/麦克风”通过情况
      try {
        videoStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
      } catch (e) {
        this.camDesc = "未授权或无可使用摄像头，请检查浏览器权限";
      }

      try {
        audioStream = await navigator.mediaDevices.getUserMedia({ video: false, audio: true });
      } catch (e) {
        this.micDesc = "未授权或无可使用麦克风，请检查浏览器权限";
      }

      const videoTracks = videoStream ? videoStream.getVideoTracks() : [];
      const audioTracks = audioStream ? audioStream.getAudioTracks() : [];

      this.camOk = videoTracks.length > 0;
      this.micOk = audioTracks.length > 0;

      // 统一保存为一个流，便于在 stopStream/beforeDestroy 中释放资源
      const combinedStream = new MediaStream();
      videoTracks.forEach((t) => combinedStream.addTrack(t));
      audioTracks.forEach((t) => combinedStream.addTrack(t));
      this.stream = combinedStream;

      if (this.camOk) {
        const v = this.$refs.preview;
        if (v) v.srcObject = combinedStream;
      }

      this.camDesc = this.camOk
        ? "摄像头检测：已成功获取摄像头画面，设备状态正常"
        : "未授权或无可使用摄像头，请检查浏览器权限";
      this.micDesc = this.micOk ? "已成功获取麦克风权限，声音录入状态正常" : "未授权或无可使用麦克风，请检查浏览器权限";

      // 如果一个都没拿到，避免留着空流引用
      if (!this.camOk && !this.micOk) this.stopStream();
      this.isDeviceChecking = false;
    },
    stopStream() {
      if (!this.stream) return;
      try {
        this.stream.getTracks().forEach((t) => t.stop());
      } catch (_) {
        // noop
      }
      this.stream = null;
    },
    revokeVoiceUrl() {
      if (!this.voice.url) return;
      try {
        URL.revokeObjectURL(this.voice.url);
      } catch (_) {
        // noop
      }
      this.voice.url = "";
      this.voice.playUrl = "";
      this.voice.knownDurationSec = 0;
      this.voice.displayCurrentSec = 0;
      this.voice.displayTotalSec = 0;
    },
    blobToDataUrl(blob) {
      return new Promise((resolve, reject) => {
        try {
          const reader = new FileReader();
          reader.onload = () => resolve(String(reader.result || ""));
          reader.onerror = () => reject(new Error("blob to dataURL failed"));
          reader.readAsDataURL(blob);
        } catch (e) {
          reject(e);
        }
      });
    },
    stopVoiceStream() {
      if (!this.voice.stream) return;
      try {
        this.voice.stream.getTracks().forEach((t) => t.stop());
      } catch (_) {
        // noop
      }
      this.voice.stream = null;
    },
    normalizeVoiceBlobForPlayback(blob) {
      if (!blob) return blob;
      const rawType = String(blob.type || "").toLowerCase();
      if (this.isMobileRecorderPreferred()) {
        if (rawType.includes("mp4") || rawType.includes("m4a")) {
          return new Blob([blob], { type: "audio/mp4" });
        }
        if (rawType === "audio/mpeg") return blob;
        return new Blob([blob], { type: "audio/mpeg" });
      }
      return blob;
    },
    isMobileRecorderPreferred() {
      const ua = (typeof navigator !== "undefined" && navigator.userAgent ? navigator.userAgent : "").toLowerCase();
      return /android|iphone|ipad|ipod|mobile/.test(ua);
    },
    isBaiduBrowser() {
      const ua = (typeof navigator !== "undefined" && navigator.userAgent ? navigator.userAgent : "").toLowerCase();
      return ua.includes("baidubrowser") || ua.includes("baidu");
    },
    getMobileRecordType() {
      return "mp3";
    },
    toggleVoiceRecord() {
      if (this.voice.recording) {
        this.stopVoiceRecord();
      } else {
        this.startVoiceRecord();
      }
    },
    applyRecordedVoiceBlob(blob) {
      if (!blob || !blob.size) return;
      const normalizedBlob = this.normalizeVoiceBlobForPlayback(blob);
      this.voice.blob = normalizedBlob;
      this.voice.url = URL.createObjectURL(normalizedBlob);
      this.voice.playUrl = this.voice.url;
      this.voice.knownDurationSec = 0;
      this.voice.displayCurrentSec = 0;
      this.voice.displayTotalSec = 0;
      const currentBlob = normalizedBlob;
      if (this.isMobileRecorderPreferred()) {
        // 终极兜底：移动端优先 dataURL 试听（部分浏览器对 blob: URL 解码不稳定）
        this.blobToDataUrl(normalizedBlob)
          .then((dataUrl) => {
            if (this.voice.blob !== currentBlob) return;
            if (dataUrl) this.voice.playUrl = dataUrl;
          })
          .catch(() => {
            // 保持 blob URL 继续兜底播放
          });
      }
      this.$nextTick(() => {
        const a = this.$refs.voiceAudio;
        if (a && a.load) a.load();
        this.syncVoiceAudioDisplayTimes();
        this.applyVoiceKnownDurationFromBlob(normalizedBlob);
      });
    },
    async startVoiceRecordByRecorderCore() {
      if (!Recorder) throw new Error("录音引擎未加载");
      return new Promise((resolve, reject) => {
        const recordType = this.getMobileRecordType();
        const rec = Recorder({
          type: recordType,
          sampleRate: 16000,
          ...(recordType === "mp3" ? { bitRate: 64 } : {}),
        });
        this.voice.mobileRecorder = rec;
        rec.open(
          () => {
            rec.start();
            resolve();
          },
          (msg, isUserNotAllow) => {
            this.voice.mobileRecorder = null;
            reject(new Error(isUserNotAllow ? "未授权麦克风权限" : msg || "录音初始化失败"));
          }
        );
      });
    },
    async startVoiceRecord() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        // 原型演示：放行，静默跳过
        return;
      }

      try {
        this.voice.recording = true;
        this.voice.chunks = [];
        this.voice.blob = null;
        this.voiceUploaded = false;
        this.revokeVoiceUrl();

        // 移动端优先使用 recorder-core；百度浏览器改走 MediaRecorder（优先 mp4）避免无声问题
        if (this.isMobileRecorderPreferred() && !this.isBaiduBrowser()) {
          await this.startVoiceRecordByRecorderCore();
          return;
        }

        const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
        this.voice.stream = stream;

        const mimeType = this.getPreferredRecordMimeType();
        const recorder = new MediaRecorder(stream, mimeType ? { mimeType } : undefined);
        this.voice.recorder = recorder;

        recorder.ondataavailable = (e) => {
          if (e.data && e.data.size > 0) this.voice.chunks.push(e.data);
        };
        recorder.onstop = () => {
          try {
            const blob = new Blob(this.voice.chunks, { type: recorder.mimeType || "audio/webm" });
            this.applyRecordedVoiceBlob(blob);
            // 原型演示：放行，不提示
          } finally {
            this.stopVoiceStream();
            this.voice.recorder = null;
            this.voice.recording = false;
          }
        };

        recorder.start();
        // 原型演示：放行，不提示
      } catch (e) {
        this.voice.recording = false;
        this.stopVoiceStream();
        this.voice.recorder = null;
        // 原型演示：放行，不提示
      }
    },
    stopVoiceRecord() {
      const mobileRecorder = this.voice.mobileRecorder;
      if (mobileRecorder) {
        mobileRecorder.stop(
          (blob) => {
            try {
              this.applyRecordedVoiceBlob(blob);
            } finally {
              try {
                mobileRecorder.close();
              } catch (_) {
                // noop
              }
              this.voice.mobileRecorder = null;
              this.voice.recording = false;
            }
          },
          () => {
            try {
              mobileRecorder.close();
            } catch (_) {
              // noop
            }
            this.voice.mobileRecorder = null;
            this.voice.recording = false;
          }
        );
        return;
      }

      const recorder = this.voice.recorder;
      if (!recorder || recorder.state !== "recording") return;
      recorder.stop();
    },
    formatVoiceClock(sec) {
      const n = Number(sec);
      const s = Math.max(0, Math.floor(Number.isFinite(n) ? n : 0));
      const m = Math.floor(s / 60);
      const r = s % 60;
      return `${m}:${String(r).padStart(2, "0")}`;
    },
    syncVoiceAudioDisplayTimes() {
      const el = this.$refs.voiceAudio;
      if (!el || !(this.voice.playUrl || this.voice.url)) return;
      const rawDur = Number(el.duration);
      const browserOk = Number.isFinite(rawDur) && rawDur > 0 && rawDur !== Infinity;
      const known = Number(this.voice.knownDurationSec);
      const knownOk = Number.isFinite(known) && known > 0;
      let total = 0;
      if (browserOk) total = rawDur;
      else if (knownOk) total = known;
      const curRaw = Number(el.currentTime);
      const cur =
        Number.isFinite(curRaw) && curRaw >= 0 ? (total > 0 ? Math.min(curRaw, total) : curRaw) : 0;
      this.voice.displayTotalSec = total;
      this.voice.displayCurrentSec = cur;
    },
    async applyVoiceKnownDurationFromBlob(blob) {
      if (!blob) return;
      try {
        const sec = await this.getVoiceDurationSeconds(blob);
        if (this.voice.blob !== blob) return;
        this.voice.knownDurationSec = Number.isFinite(sec) && sec > 0 ? sec : 0;
        this.syncVoiceAudioDisplayTimes();
      } catch (_) {
        // noop
      }
    },
    async playVoice() {
      const a = this.$refs.voiceAudio;
      if (!a || !a.play) return;
      const playSrc = this.voice.playUrl || this.voice.url;
      if (!playSrc) {
        this.$message.warning("请先完成录音");
        return;
      }
      // 百度 App 内核下，优先走独立 Audio 实例，避免页面内 <audio> 播放失败
      if (this.isBaiduBrowser()) {
        try {
          if (this.voice.fallbackPlayer && this.voice.fallbackPlayer.pause) {
            try {
              this.voice.fallbackPlayer.pause();
            } catch (_) {
              // noop
            }
          }
          const standalone = new Audio(playSrc);
          standalone.preload = "auto";
          standalone.currentTime = 0;
          this.voice.fallbackPlayer = standalone;
          await standalone.play();
          return;
        } catch (err) {
          const reason = err && err.name ? `（${err.name}）` : "";
          this.$message.warning(`试听失败，百度浏览器内核播放受限${reason}，请重录后再试`);
          return;
        }
      }
      try {
        if (this.voice.fallbackPlayer && this.voice.fallbackPlayer.pause) {
          try {
            this.voice.fallbackPlayer.pause();
          } catch (_) {
            // noop
          }
          this.voice.fallbackPlayer = null;
        }
        if (a.pause) a.pause();
        a.currentTime = 0;
        if (a.src !== playSrc) a.src = playSrc;
        if (!this.isMobileRecorderPreferred() && a.load) a.load();
        this.syncVoiceAudioDisplayTimes();
        await a.play();
      } catch (err) {
        try {
          const fallback = new Audio(playSrc);
          fallback.preload = "auto";
          this.voice.fallbackPlayer = fallback;
          await fallback.play();
        } catch (_) {
          const reason = err && err.name ? `（${err.name}）` : "";
          this.$message.warning(`试听失败，当前浏览器音频播放受限${reason}，请重录后重试`);
        }
      }
    },
    clearVoice() {
      this.revokeVoiceUrl();
      this.voice.chunks = [];
      this.voice.blob = null;
      this.voice.playUrl = "";
      if (this.voice.mobileRecorder) {
        try {
          this.voice.mobileRecorder.close();
        } catch (_) {
          // noop
        }
        this.voice.mobileRecorder = null;
      }
      this.voice.knownDurationSec = 0;
      this.voice.displayCurrentSec = 0;
      this.voice.displayTotalSec = 0;
      this.voiceUploaded = false;
      if (this.$refs.voiceAudio && this.$refs.voiceAudio.pause) {
        try {
          this.$refs.voiceAudio.pause();
        } catch (_) {
          // noop
        }
      }
      if (this.voice.fallbackPlayer && this.voice.fallbackPlayer.pause) {
        try {
          this.voice.fallbackPlayer.pause();
        } catch (_) {
          // noop
        }
        this.voice.fallbackPlayer = null;
      }
      // this.$message.success("录音已清除（可选）。");
    },
    async checkNetwork() {
      this.netLevel = "unknown";
      this.netText = "检测中";
      this.netDesc = "检测网络中…";
      const GOOD_THRESHOLD_MBPS = 0.8; // 800Kbps

      const failDesc = "网络检测失败：当前网络连接不稳定/未连接网络，无法支持视频面试，请检查网络设置后重试";

      // 1) 基础连通性判断
      const online = typeof navigator !== "undefined" && typeof navigator.onLine === "boolean" ? navigator.onLine : true;
      if (!online) {
        this.netLevel = "bad";
        this.netText = "失败";
        this.netDesc = failDesc;
        return;
      }

      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const effectiveType = conn && conn.effectiveType ? String(conn.effectiveType).toLowerCase() : "";
      const rtt = conn && typeof conn.rtt === "number" ? conn.rtt : undefined;
      const downlink = conn && typeof conn.downlink === "number" ? conn.downlink : undefined;

      const getTypeText = () => (effectiveType ? effectiveType : "未知");

      // 2) 优先用 Network Information API（浏览器给出的 downlink 是 Mbps 估计）
      if (typeof downlink === "number") {
        try {
          const downlink1 = downlink;
          // 再读取一次以估计“稳定性/卡顿风险”（这里只能做轻量估计）
          await new Promise((res) => setTimeout(res, 800));
          const downlink2 = conn && typeof conn.downlink === "number" ? conn.downlink : downlink1;

          const avg = (downlink1 + downlink2) / 2;
          const delta = Math.abs(downlink2 - downlink1);
          // downlink 估计值可能抖动较大；用更宽松阈值降低“1.5Mbps 仍判 warn”的误判
          const stableByDelta = avg > 0 ? delta / avg <= 0.25 : false;
          const stableByRtt = typeof rtt === "number" ? rtt <= 450 : true;
          const stable = stableByDelta && stableByRtt;

          // 口径：大于等于 800Kbps 视为正常，低于 800Kbps 视为建议优化
          if (avg >= GOOD_THRESHOLD_MBPS) {
            this.netLevel = "ok";
            this.netText = "良好";
            this.netDesc = "网络检测：当前网速稳定，满足高清视频面试需求，可正常进行面试";
            return;
          }

          this.netLevel = "warn";
          this.netText = "建议优化";
          this.netDesc = `当前网速：${avg.toFixed(1)}Mbps（${getTypeText()}），建议≥0.8Mbps，可继续但可能卡顿`;
        } catch (e) {
          this.netLevel = "warn";
          this.netText = "建议优化";
          this.netDesc = "网络检测受限，建议优化网络后重试";
        }
        return;
      }

      // 3) fallback：通过下载固定大小文件估算带宽（浏览器侧近似测速）
      try {
        const sizeBytes = 1024 * 1024; // 1MB
        const testUrl = "https://speed.hetzner.de/1MB.bin";

        const sample = async () => {
          const start = performance.now();
          let controller = null;
          if (typeof AbortController !== "undefined") {
            controller = new AbortController();
            setTimeout(() => controller && controller.abort(), 5000);
          }

          await fetch(testUrl, {
            method: "GET",
            cache: "no-store",
            mode: "no-cors",
            signal: controller ? controller.signal : undefined,
          });

          const durationMs = performance.now() - start;
          if (!durationMs || durationMs <= 0) throw new Error("invalid duration");
          const mbps = (sizeBytes * 8) / durationMs / 1e6;
          return mbps;
        };

        const s1 = await sample();
        const s2 = await sample();
        const min = Math.min(s1, s2);
        const max = Math.max(s1, s2);
        const avg = (s1 + s2) / 2;
        // fallback 的测速估计会有波动，用更宽松阈值降低误判
        const stable = min > 0 ? max / min <= 1.35 : false;

        if (avg >= GOOD_THRESHOLD_MBPS) {
          this.netLevel = "ok";
          this.netText = "良好";
          this.netDesc = "网络检测：当前网速稳定，满足高清视频面试需求，可正常进行面试";
          return;
        }

        this.netLevel = "warn";
        this.netText = "建议优化";
        this.netDesc = `当前网速：${avg.toFixed(1)}Mbps（${getTypeText()}），建议≥0.8Mbps，可继续但可能卡顿`;
      } catch (e) {
        this.netLevel = "warn";
        this.netText = "建议优化";
        this.netDesc = "网络检测受限，建议优化网络后重试";
      }
    },
    async checkEnvironment() {
      this.envChecked = false;
      this.envLevel = "unknown";
      this.envDesc = "检测中…";

      const reasons = [];
      let score = 0;

      try {
        // 1) 自动化/无头痕迹（只能做启发式判断）
        if (typeof navigator !== "undefined" && navigator.webdriver) {
          reasons.push("检测到 webdriver 自动化标记");
          score += 40;
        }

        // 2) UA 中的虚拟化关键字
        const ua = (typeof navigator !== "undefined" && navigator.userAgent ? navigator.userAgent : "").toLowerCase();
        const vmUaKeywords = ["vmware", "virtualbox", "vbox", "kvm", "qemu", "xen", "parallels", "hyper-v"];
        if (vmUaKeywords.some((k) => ua.includes(k))) {
          reasons.push("用户代理疑似虚拟化环境");
          score += 30;
        }

        // 3) WebGL 渲染器（虚拟显卡常见特征）
        const webgl = this.getWebGLVendorRenderer();
        const vendor = webgl && webgl.vendor ? String(webgl.vendor).toLowerCase() : "";
        const renderer = webgl && webgl.renderer ? String(webgl.renderer).toLowerCase() : "";
        const glText = `${vendor} ${renderer}`;
        const vmGlKeywords = [
          "vmware",
          "virtualbox",
          "vbox",
          "kvm",
          "qemu",
          "llvmpipe",
          "software",
          "swiftshader",
          "transgaming",
          "microsoft basic display adapter",
          "parallels",
          "hyper-v",
        ];
        if (glText.trim() && vmGlKeywords.some((k) => glText.includes(k))) {
          reasons.push(`WebGL 渲染器疑似虚拟化（${vendor || "未知"} / ${renderer || "未知"}）`);
          score += 55;
        }

        // 4) 低配特征（仅辅助，不作为单一结论）
        const deviceMemory = typeof navigator !== "undefined" ? navigator.deviceMemory : undefined;
        if (typeof deviceMemory === "number" && deviceMemory > 0 && deviceMemory <= 4) {
          reasons.push(`设备内存较小（${deviceMemory}GB）`);
          score += 15;
        }

        const hc = typeof navigator !== "undefined" ? navigator.hardwareConcurrency : undefined;
        if (typeof hc === "number" && hc > 0 && hc <= 2) {
          reasons.push(`CPU 核心数偏低（${hc}）`);
          score += 15;
        }

        const w = typeof screen !== "undefined" && screen.width ? screen.width : 0;
        const h = typeof screen !== "undefined" && screen.height ? screen.height : 0;
        if (w && h && w <= 1280 && h <= 720) {
          reasons.push(`屏幕分辨率偏小（${w}x${h}）`);
          score += 10;
        }
      } catch (e) {
        // 检测受限时不阻断，仅降级为 warn
        this.envLevel = "warn";
        this.envDesc = "检测受限（浏览器权限/能力不足），建议使用真实设备";
        this.envChecked = true;
        return;
      }

      if (score >= 60) this.envLevel = "bad";
      else if (score >= 25) this.envLevel = "warn";
      else this.envLevel = "ok";

      const topReasons = reasons.length ? reasons.slice(0, 3).join("；") : "";
      if (!reasons.length) {
        this.envDesc = "未检测到虚拟机运行、或开启录屏工具，环境符合面试要求";
      } else if (this.envLevel === "bad") {
        this.envDesc = "检测到虚拟机运行/录屏工具开启，请关闭虚拟机或更换设备后重试";
      } else if (this.envLevel === "warn") {
        this.envDesc = `存在环境风险：${topReasons}。建议使用真实设备。`;
      } else {
        this.envDesc = "未检测到虚拟机运行、或开启录屏工具，环境符合面试要求";
      }

      this.envChecked = true;
    },
    getWebGLVendorRenderer() {
      try {
        if (typeof document === "undefined") return { vendor: "", renderer: "" };
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (!gl) return { vendor: "", renderer: "" };

        const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
        const vendor = debugInfo ? gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) : gl.getParameter(gl.VENDOR);
        const renderer = debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER);
        return { vendor: vendor || "", renderer: renderer || "" };
      } catch (_) {
        return { vendor: "", renderer: "" };
      }
    },
    async toggleFullscreen() {
      const el = this.getFullscreenTarget();
      if (!el) return;
      try {
        if (!document.fullscreenElement) await el.requestFullscreen();
        else await document.exitFullscreen();
      } catch (_) {
        this.$message.warning("全屏失败：浏览器可能阻止了全屏请求");
      }
    },
    async exitFullscreen() {
      try {
        if (document.fullscreenElement) await document.exitFullscreen();
      } catch (_) {
        this.$message.warning("退出全屏失败，请按 Esc 键重试");
      }
    },
    prev() {
      this.step = Math.max(1, this.step - 1);
    },
    onNextActionClick() {
      if (this.uploadingVoice) {
        this.$message.warning("声纹上传中，请稍候");
        return;
      }
      if (!this.canGoNext) {
        if (this.step === 2) {
          const messages = [];
          if (!this.voice.blob || !this.voice.url || this.voice.recording) {
            messages.push(this.voice.recording ? "请先结束录音" : "请先完成录音");
          }
          if (!this.pledgesOk) {
            messages.push("请先勾选面试承诺");
          }
          this.$message.warning(messages.length ? messages.join("，") : "请先完成当前步骤");
          return;
        }
        this.$message.warning("请先完成当前步骤");
        return;
      }
      this.next();
    },
    async next() {
      if (!this.canGoNext || this.uploadingVoice) return;

      if (this.step < 2) {
        this.step += 1;
        return;
      }

      // Step 2 安全兜底：确保已完成录音后再进入等待室
      if (this.step === 2 && (!this.voice.blob || !this.voice.url || this.voice.recording)) {
        this.$message.warning("请先完成录音后再进入面试间。");
        return;
      }

      // Step 2 点击“进入面试间”时追加时长校验：声纹时长需 > 5 秒
      if (this.step === 2 && this.voice.blob) {
        const durationSec = await this.getVoiceDurationSeconds(this.voice.blob);
        if (durationSec <= 5) {
          this.$message.warning("声纹录制时间较短，需要大于5秒");
          return;
        }
      }

      // Step 2：上传声纹成功后才进入第 3 步等待室
      if (this.voice.blob && !this.voiceUploaded) {
        try {
          await this.enterInterviewRoom();
        } catch (e) {
          console.error("声纹上传失败", e);
          this.$message.warning("声纹上传失败，请重试后再进入面试间。");
          return;
        }
      }
      this.showWaitingRoom();
    },
    async enterInterviewRoom() {
      if (this.uploadingVoice || this.voiceUploaded) return;

      this.uploadingVoice = true;
      try {
        if (!this.voice.blob) throw new Error("录音内容缺失");
        if (!this.interviewId) throw new Error("缺少 interview_id，无法上传声纹");

        // 统一转成 File 再上传，确保 multipart/form-data 中存在 file 字段且带文件名
        const uploadPayload = this.buildVoiceUploadPayload(this.voice.blob);
        await uploadVoiceprint(uploadPayload.file, this.interviewId, 0);
        this.voiceUploaded = true;
      } finally {
        this.uploadingVoice = false;
      }
    },
    getPreferredRecordMimeType() {
      if (typeof MediaRecorder === "undefined" || !MediaRecorder.isTypeSupported) return "";
      const candidates = this.isBaiduBrowser()
        ? [
            "audio/mp4",
            "audio/mpeg",
            "audio/webm;codecs=opus",
            "audio/webm",
            "audio/ogg;codecs=opus",
            "audio/wav",
          ]
        : [
            "audio/wav",
            "audio/mp4",
            "audio/mpeg",
            "audio/ogg;codecs=opus",
            "audio/webm;codecs=opus",
            "audio/webm",
          ];
      return candidates.find((item) => MediaRecorder.isTypeSupported(item)) || "";
    },
    buildVoiceUploadPayload(blob) {
      const mime = String((blob && blob.type) || "").toLowerCase();
      let ext = "webm";
      if (mime.includes("wav")) ext = "wav";
      else if (mime.includes("mpeg") || mime.includes("mp3")) ext = "mp3";
      else if (mime.includes("mp4")) ext = "m4a";
      else if (mime.includes("ogg")) ext = "ogg";

      // 尽量对齐 swagger 示例：mp4 -> m4a 且 type 为 audio/x-m4a
      const normalizedType = mime.includes("mp4") ? "audio/x-m4a" : mime || "audio/webm";
      const filename = `voice_${Date.now()}.${ext}`;
      const file = new File([blob], filename, {
        type: normalizedType,
        lastModified: Date.now(),
      });
      return { file, filename };
    },
    async getVoiceDurationSeconds(blob) {
      if (!blob) return 0;
      // 优先用 Web Audio 解码，拿到更稳定的时长
      try {
        const arrayBuffer = await blob.arrayBuffer();
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (AudioCtx) {
          const ctx = new AudioCtx();
          try {
            const audioBuffer = await ctx.decodeAudioData(arrayBuffer.slice(0));
            const d = Number(audioBuffer && audioBuffer.duration);
            if (Number.isFinite(d) && d > 0) return d;
          } finally {
            if (ctx && typeof ctx.close === "function") await ctx.close();
          }
        }
      } catch (_) {
        // ignore and fallback
      }

      // 回退：通过 audio 元素 metadata 获取时长
      try {
        const objectUrl = URL.createObjectURL(blob);
        const duration = await new Promise((resolve) => {
          const audio = document.createElement("audio");
          let settled = false;
          const done = (val) => {
            if (settled) return;
            settled = true;
            resolve(val);
          };
          audio.preload = "metadata";
          audio.onloadedmetadata = () => done(Number(audio.duration) || 0);
          audio.onerror = () => done(0);
          audio.src = objectUrl;
        });
        URL.revokeObjectURL(objectUrl);
        return Number(duration) || 0;
      } catch (_) {
        return 0;
      }
    },
    showWaitingRoom() {
      this.step = 3;
      this.roomReady = false;
      this.waitingError = false;
      this.waitingErrorMsg = "连接异常，请稍后重试";
      this.waitingStatus = "正在等待面试官进入房间...";
      this.waitingStartTime = Date.now();
      this.startPolling();
      this.startCountdown();
    },
    startPolling() {
      this.stopPolling();
      this.pollInterval = setInterval(async () => {
        try {
          const res = await this.checkRoomStatus();
          if (res.roomExists) {
            this.stopPolling();
            this.roomReady = true;
            // this.$message.success("面试官已进入，现在可以进入面试间了");
          } else if (res.error) {
            this.waitingError = true;
            this.waitingErrorMsg = res.message || this.waitingErrorMsg;
            this.stopPolling();
            this.stopCountdown();
          }
        } catch (e) {
          console.error("轮询失败", e);
          this.waitingError = true;
          this.waitingErrorMsg = (e && e.message) || this.waitingErrorMsg;
          this.stopPolling();
          this.stopCountdown();
        }
      }, 3000);
    },
    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    },
    getInterviewStartTimestamp() {
      const raw = String((this.inviteInfo && this.inviteInfo.interview_time) || "").trim();
      if (!raw) return NaN;
      const match = raw.match(/^(\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2})\s*-\s*\d{2}:\d{2}$/);
      const startText = match && match[1] ? match[1] : "";
      if (!startText) return NaN;
      const normalized = startText.replace(/-/g, "/");
      const parsed = new Date(normalized).getTime();
      return Number.isFinite(parsed) ? parsed : NaN;
    },
    startCountdown() {
      this.stopCountdown();
      const update = () => {
        const nowMs = Date.now();
        const interviewStartMs = this.getInterviewStartTimestamp();

        if (Number.isFinite(interviewStartMs) && nowMs < interviewStartMs) {
          this.countdownText = "还未到面试时间，请耐心等待。";
          return;
        }

        const waitStartMs = Number.isFinite(interviewStartMs) ? Math.max(this.waitingStartTime || nowMs, interviewStartMs) : (this.waitingStartTime || nowMs);
        const elapsedSec = Math.floor((nowMs - waitStartMs) / 1000);

        if (elapsedSec > 600) {
          this.countdownText = "面试官可能因其他原因延迟，可联系企业 HR 确认";
          return;
        }

        const min = Math.floor(elapsedSec / 60);
        const sec = elapsedSec % 60;
        this.countdownText = `等待时间：${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
      };
      update();
      this.countdownTimer = setInterval(update, 1000);
    },
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    retryPolling() {
      this.waitingError = false;
      this.startCountdown();
      this.startPolling();
    },
    enterRoom() {
      // 第 2 步已完成录音上传，这里直接进入面试间
      this.$router.push({
        path: "/candidate/room",
        query: { name: this.name, phone: this.phone, interview_id: this.interviewId },
      });
    },
    backToPrep() {
      this.step = 2;
      this.voiceUploaded = false;
      this.stopPolling();
      this.stopCountdown();
    },
    async checkRoomStatus() {
      const id = this.interviewId;
      if (!id) {
        return { error: true, message: "缺少 interview_id，无法查询面试官房间状态" };
      }

      const res = await getInterviewRoomStatus(id);
      const data = (res && res.data) ? res.data : {};

      const ok = !!(res && (res.success === true || res.code === 200));
      if (!ok) {
        return {
          error: true,
          message: (res && res.msg) || "连接异常，请稍后重试",
        };
      }

      // room_status: 1/2 均允许候选人进入面试间
      const roomStatus = Number(data.room_status);
      return { roomExists: roomStatus === 1 || roomStatus === 2 };
    },
  },
};
</script>

<style scoped>
.page {
  min-height: 100%;
  padding: 18px 16px 26px;
  background: #f5f7fa;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 28px 18px 42px 18px;
  box-sizing: border-box;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 750;
  letter-spacing: 0.2px;
}

.logo {
  display: block;
  object-fit: contain;
  background: transparent;
  width: 90px;
  height: 32px;
}

.brand-title {
  font-size: 14px;
  opacity: 0.92;
}

.brand-sub {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #f8fafc;
  font-size: 12px;
}

.pill-info strong {
  font-weight: 800;
}

.pill-link {
  cursor: pointer;
  border-color: rgba(37, 99, 235, 0.3);
  color: #2563eb;
  background: #eff6ff;
}

.pill-link:hover {
  background: #dbeafe;
}

main {
  margin-top: 16px;
}

.stepper {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 14px 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
}

.step {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid transparent;
  min-width: 210px;
}

.step .dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.15);
  background: transparent;
}

.step .title {
  font-weight: 700;
}

.step .sub {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.step.active {
  border-color: rgba(37, 99, 235, 0.3);
  background: rgba(37, 99, 235, 0.05);
}

.step.active .dot {
  border-color: rgba(37, 99, 235, 1);
  background: rgba(37, 99, 235, 1);
}

.step.done .dot {
  border-color: rgba(34, 197, 94, 1);
  background: rgba(34, 197, 94, 1);
}

.arrow {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  color: #1f2937;
}

.content {
  margin-top: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.content-inner {
  padding: 18px;
}

.grid {
  display: grid;
  grid-template-columns: 1.25fr 0.95fr;
  gap: 16px;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  background: #f8fafc;
  overflow: hidden;
}

.card-h {
  padding: 12px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}

.card-h strong {
  font-weight: 800;
}

.card-b {
  padding: 14px;
}

.video-wrap {
  position: relative;
  aspect-ratio: 16 / 9;
  background: #000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.fs-exit-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 3;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 999px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.7);
  color: #ffffff;
  cursor: pointer;
}

.fs-exit-icon {
  width: 18px;
  height: 18px;
  display: block;
}

.fs-exit-btn:hover {
  background: rgba(15, 23, 42, 0.9);
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.local-preview-flip {
  width: 100%;
  height: 100%;
}

.video-wrap--preview-flip-shell .local-preview-flip {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  transform-origin: center center;
}

video.local-mirror-preview.local-mirror-preview--css-flip {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  transform-origin: center center;
}

.video-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 12px;
  background: linear-gradient(180deg, transparent 50%, rgba(0, 0, 0, 0.55));
  pointer-events: none;
}

.badge-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.badge {
  pointer-events: none;
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  color: #fff;
}

.badge.ok {
  background: rgba(34, 197, 94, 0.8);
}

.badge.warn {
  background: rgba(245, 158, 11, 0.8);
}

.badge.bad {
  background: rgba(239, 68, 68, 0.8);
}

.btn-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

button {
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #ffffff;
  color: #1a1a2e;
  padding: 10px 12px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 700;
  font-size: 13px;
}

button:hover {
  background: #f8fafc;
}

button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.primary {
  border-color: rgba(37, 99, 235, 0.3);
  background: #2563eb;
  color: #fff;
}

.primary:hover {
  background: #1d4ed8;
}

.ghost {
  background: transparent;
}

.danger {
  border-color: rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.danger:hover {
  background: rgba(239, 68, 68, 0.15);
}

.list {
  display: grid;
  gap: 10px;
}

.item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 10px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  background: #ffffff;
}

.left {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.icon {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #f1f5f9;
  flex: 0 0 auto;
  margin-top: 1px;
}

.meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.meta .k-row {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  width: 100%;
}

.meta .k {
  font-weight: 800;
  flex: 1 1 auto;
  min-width: 0;
}

.meta .d {
  color: #6b7280;
  font-size: 12px;
}

.status {
  flex: 0 0 auto;
  font-weight: 800;
  font-size: 12px;
  padding: 6px 9px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #f1f5f9;
  margin-top: 1px;
}

.status.ok {
  border-color: rgba(34, 197, 94, 0.3);
  background: rgba(34, 197, 94, 0.1);
  color: #166534;
}

.status.warn {
  border-color: rgba(245, 158, 11, 0.3);
  background: rgba(245, 158, 11, 0.1);
  color: #b45309;
}

.status.bad {
  border-color: rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.1);
  color: #b91c1c;
}

.status--mobile {
  display: none;
  margin-left: auto;
}

.status--desktop {
  display: inline-flex;
}

.fineprint {
  margin-top: 8px;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.55;
}

.voice-read-tip {
  font-size: 14px;
  color: #1a1a2e;
  line-height: 1.5;
}

.voice-read-content {
  display: inline-block;
  margin-top: 4px;
  font-weight: 850;
}

.privacy-link {
  color: #2563eb;
  text-decoration: none;
  cursor: pointer;
}

.privacy-link:hover {
  text-decoration: underline;
}

.hr {
  height: 1px;
  background: rgba(255, 255, 255, 0.6);
  margin: 12px 0;
}

.note {
  color: #6b7280;
  font-size: 12px;
  max-width: 720px;
  line-height: 1.5;
}

.split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.checklist {
  display: grid;
  gap: 10px;
}

label.chk {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
}

label.chk input {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

label.chk .txt {
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 1.5;
}

label.chk .txt .h {
  font-weight: 850;
  line-height: 1.5;
}

label.chk .txt .s {
  font-size: 12px;
  color: #6b7280;
}


.voice-audio-block {
  width: 100%;
  margin-top: 10px;
}

.voice-audio-block .voiceAudio {
  width: 100%;
  margin-top: 0;
}

.voice-audio-time {
  margin-top: 6px;
  font-size: 14px;
  text-align: left;
  font-variant-numeric: tabular-nums;
  color: #6b7280;
}

.voiceAudio {
  width: 100%;
  margin-top: 10px;
}

@media (min-width: 769px) {
  .voice-collect-body {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    text-align: left;
  }

  .voice-collect-body .btn-row {
    justify-content: center;
  }

  .voice-collect-body .voiceAudio {
    max-width: 420px;
  }
}

/* 等待室 */
.waiting-room {
  text-align: center;
  padding: 40px 20px;
}

.waiting-room h2 {
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 8px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(37, 99, 235, 0.1);
  border-radius: 50%;
  border-top-color: #2563eb;
  animation: spin 1s ease-in-out infinite;
  margin: 20px auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.waiting-status {
  font-size: 16px;
  color: #1a1a2e;
  margin: 20px 0;
}

.waiting-tip {
  color: #6b7280;
  font-size: 13px;
  max-width: 265px;
  margin: 20px auto;
  line-height: 1.6;
  text-align: right;
}

.waiting-tip p {
  margin: 6px 0;
}

.waiting-tip-row {
  display: grid;
  grid-template-columns: 112px 1fr;
  gap: 10px;
  align-items: center;
  margin: 6px 0;
}

.waiting-tip-row--center {
  /* 覆盖默认两列布局：让“图标 + 文本”整体居中并占满一行 */
  display: flex;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

.waiting-tip-row--center .wt-label {
  width: auto;
}

.waiting-tip-row--center .wt-value {
  text-align: center;
}

.wt-label {
  color: #6b7280;
  font-weight: 700;
  white-space: nowrap;
}

.wt-value {
  color: #1a1a2e;
  font-weight: 600;
  text-align: left;
}

.waiting-tip-row--interview-time .wt-value {
  /* 强制“面试时间”右侧值占一行，避免在 max-width 下自动换行 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  min-width: 0;
}

.countdown {
  font-size: 14px;
  color: #6b7280;
  margin-top: 10px;
  text-align: center;
}

.room-ready {
  background: transparent;
  border: none;
  padding: 0;
  margin: 20px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.room-ready-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 18px;
}

.room-ready-good {
  width: 22px;
  height: auto;
}

.room-ready-title-text {
  font-size: 18px;
  font-weight: 850;
  color: #1a1a2e;
}

.room-ready-img-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 18px;
}

.room-ready-interview-img {
  width: 280px;
  max-width: 100%;
  height: auto;
}

.enter-btn {
  width: 100%;
  max-width: 280px;
  padding: 12px 30px;
  font-size: 16px;
}

.error-box {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid #ef4444;
  border-radius: 16px;
  padding: 20px;
  margin: 20px 0;
  color: #ef4444;
}

.error-box p {
  margin-bottom: 12px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 18px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  background: #f8fafc;
}

.next-action-btn--disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* 移动端响应式（≤768px） */
@media (max-width: 768px) {
  .page {
    padding: 12px;
    min-height: 100vh;
    box-sizing: border-box;
  }

  .container {
    padding: 0px;
  }

  .header {
    padding: 12px 14px;
    border-radius: 12px;
  }

  .logo {
    width: 90px;
    height: auto;
    font-size: 18px;
  }

  .brand-title {
    font-size: 13px;
  }

  .brand-sub {
    font-size: 11px;
  }

  main {
    margin-top: 12px;
  }

  .stepper {
    flex-direction: column;
    gap: 2px;
    padding: 12px 10px;
    border-radius: 12px;
  }

  .arrow {
    width: 25px;
    height: 25px;
    font-size: 20px;
    transform: rotate(90deg);
  }

  .step {
    min-width: 0;
    width: 100%;
    padding: 10px 12px;
    border-radius: 10px;
  }

  .step .title {
    font-size: 14px;
  }

  .step .sub {
    font-size: 11px;
  }

  .content {
    margin-top: 12px;
    border-radius: 12px;
  }

  .content-inner {
    padding: 14px 12px;
  }

  .grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .split {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .card-h {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 10px 12px;
  }

  .card-h .btn-row {
    width: auto;
    justify-content: flex-end;
    flex: 0 0 auto;
  }

  .card-b {
    padding: 12px;
  }

  .video-wrap {
    aspect-ratio: 4 / 3;
  }

  .video-overlay {
    padding: 8px;
  }

  .badge {
    font-size: 9px;
    padding: 3px 6px;
  }

  .btn-row {
    gap: 8px;
  }

  .btn-row button {
    min-height: 34px;
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 8px;
  }

  .item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 10px;
  }

  .item .status {
    align-self: flex-start;
  }

  .item .status--desktop {
    display: none;
  }

  .item .left {
    width: 100%;
  }

  .item .meta {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
  }

  .item .meta .k-row {
    width: 100%;
  }

  .item .status--mobile {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    padding: 3px 6px;
    font-size: 12px;
    line-height: 1.2;
    width: 58px;
    min-width: 58px;
    min-height: 24px;
    text-align: center;
  }

  .fineprint {
    font-size: 12px;
  }

  .voice-read-tip {
    font-size: 13px;
  }

  .note {
    font-size: 11px;
  }

  label.chk {
    padding: 10px;
  }

  label.chk .txt .h {
    font-size: 13px;
  }

  label.chk .txt .s {
    font-size: 11px;
  }

  .footer {
    padding: 12px 14px;
  }

  .footer .btn-row button {
    min-height: 36px;
    flex: 1;
    padding: 7px 12px;
    font-size: 12px;
    border-radius: 8px;
  }

  .waiting-room {
    padding: 24px 16px;
  }

  .waiting-room h2 {
    font-size: 18px;
  }

  .error-box {
    padding: 20px 16px;
  }

  .enter-btn {
    width: 100%;
    min-height: 48px;
  }

  .waiting-tip-row {
    grid-template-columns: 92px 1fr;
  }

  .room-ready {
    padding: 0;
  }
}

/* 协议弹窗（el-dialog 挂载到 body，需深度选择器） */
::v-deep .doc-dialog {
  max-width: calc(100vw - 24px);
}

::v-deep .doc-dialog .el-dialog__body {
  padding: 0;
}

::v-deep .doc-dialog .doc-iframe {
  width: 100%;
  height: 70vh;
  min-height: 400px;
  border: none;
  border-radius: 8px;
  display: block;
}
</style>

